var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PositionTemplate',{attrs:{"position":_vm.position,"currency":_vm.currency,"status":"accepted"}})
}
var staticRenderFns = []

export { render, staticRenderFns }